import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ImageFileFooterIcon = (props: IconProps) => (
  <Icon w="20px" h="20px" viewBox="0 0 20 20" {...props}>
    <path d="M15.8333 4.16667V15.8333H4.16667V4.16667H15.8333ZM15.8333 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM11.7833 9.88333L9.28333 13.1083L7.5 10.95L5 14.1667H15L11.7833 9.88333Z" />
  </Icon>
);

export default memo(ImageFileFooterIcon);
